class TabsSection extends HTMLElement {
  static selectors = {
    section: '.shopify-section',
    heading: '.image-with-tabs__heading',
    tablist: '.image-with-tabs__tabs-header',
    buttons: '.image-with-tabs__tab-button',
    panels: '.image-with-tabs__tab-panel',
  };
  static classes = {
    buttonActive: 'image-with-tabs__tab-button--active'
  };
  tablist = null;
  buttons = null;
  panels = null;
  activeTabIndex = 0

  connectedCallback() {
    this.tablist = this.querySelector(TabsSection.selectors.tablist);
    this.buttons = this.querySelectorAll(TabsSection.selectors.buttons);
    this.panels = this.querySelectorAll(TabsSection.selectors.panels);
    this.init();
  }

  init() {
    if (!this.tablist || !this.buttons || !this.panels) return;

    this.tablist.setAttribute('role', 'tablist');
    this.tablist.addEventListener('keydown', this.onKeyDown.bind(this));

    const heading = this.closest(TabsSection.selectors.section).querySelector(TabsSection.selectors.heading);
    
    if (heading) {
      this.tablist.setAttribute('aria-labelledby', heading.id);
    }
    
    this.buttons.forEach((button, index) => {
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', this.panels[index].id);

      const isActive = index === 0;

      if (isActive) {
        this.activeTabIndex = index;
      } else {
        button.setAttribute('tabindex', '-1');
      }

      button.setAttribute('aria-selected', String(isActive));
      button.addEventListener('click', () => this.switchTab(index));
    });

    this.panels.forEach((panel, index) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', this.buttons[index].id);
      panel.setAttribute('tabindex', '0');
    });
  }

  onKeyDown(event) {
    let needPreventDefault = false;
    let nextIndex = null;

    switch (event.key) {
      case 'ArrowLeft':
        nextIndex = (this.activeTabIndex - 1) < 0 ? (this.buttons.length - 1) : (this.activeTabIndex - 1);
        this.switchTab(nextIndex);
        needPreventDefault = true;
        break;
      case 'ArrowRight':
        nextIndex = (this.activeTabIndex + 1) >= this.buttons.length ? 0 : (this.activeTabIndex + 1);
        this.switchTab(nextIndex);
        needPreventDefault = true;
        break;
      case 'Home':
        this.switchTab(0);
        needPreventDefault = true;
        break;
      case 'End':
        this.switchTab(this.buttons.length - 1);
        needPreventDefault = true;
        break;
      default:
        break;
    }

    if (needPreventDefault) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  switchTab(index) {
    if (index === this.activeTabIndex) return;

    if (index < 0 || index >= this.buttons.length) return;

    this.buttons[this.activeTabIndex].setAttribute('aria-selected', 'false');
    this.buttons[this.activeTabIndex].setAttribute('tabindex', '-1');
    this.buttons[this.activeTabIndex].classList.remove(TabsSection.classes.buttonActive);
    this.panels[this.activeTabIndex].hidden = true;

    this.buttons[index].setAttribute('aria-selected', 'true');
    this.buttons[index].removeAttribute('tabindex');
    this.buttons[index].classList.add(TabsSection.classes.buttonActive);
    this.panels[index].hidden = false;
    
    if (document.activeElement !== this.buttons[index]) {
      this.buttons[index].focus();  
    }
    
    this.activeTabIndex = index;
  }
}

customElements.define('tabs-section', TabsSection);